import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { GlobalSearchResponse } from '@app/interfaces/public/global-search.interfaces';

@Injectable({ providedIn: 'root' })
export class GlobalSearchService {
  private readonly searchUrl = `${environment.apiUrl}/public/search`;

  constructor(private readonly http: HttpClient) {}

  search(query: string, limit: number = 80): Observable<GlobalSearchResponse> {
    const params = new HttpParams()
      .set('q', query.trim())
      .set('limit', String(limit));

    return this.http.get<GlobalSearchResponse>(this.searchUrl, { params });
  }
}
